(function (jQuery) {
  jQuery.gfForm = function (element, options) {
    const defaults = {
      onSuccess: function () {},
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      if ($element.hasClass('design-panel')) {
        // Lazyload Design panel
        setTimeout(function () {
          $element.find('.columns').gfSettingGroup();
        }, 50);
      } else {
        $element.find('.columns').gfSettingGroup();
      }

      _this.applyToggle();
    };

    this.applyToggle = function () {
      const $columns = $gfLeftSideBar.find('.design-panel .columns');
      if ($columns.length > 0) {
        let toggle_cookie = localStorage.getItem('design_options_toggle');

        if (toggle_cookie) {
          try {
            toggle_cookie = JSON.parse(toggle_cookie);
            const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
            if (toggle_cookie.id == merId) {
              jQuery.each(toggle_cookie.data, function (key, value) {
                if (value.toggle == true) {
                  const $column = $gfLeftSideBar.find('.design-panel .columns[data-caption="' + value.name + '"]');
                  if ($column.data('gfsettinggroup')) {
                    $column.data('gfsettinggroup').onToggle();
                  }
                }
              });
            } else {
              toggle_cookie = {
                id: merId,
                data: {},
              };
              try {
                localStorage.setItem('design_options_toggle', JSON.stringify(toggle_cookie));
              } catch (e) {
                if (e.code == 22) {
                  // Storage full, maybe notify user or do some clean-up
                }
              }
            }
          } catch (e) {}
        }
      }
    };
    _this.onOpacity = function () {
      $element.find('.gfFormWrapper').css({
        display: 'block',
      });
    };
    _this.offOpacity = function () {
      $element.find('.gfFormWrapper').css({
        display: 'none',
      });
    };

    this.init();
  };
  jQuery.fn.gfForm = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfform')) {
        const plugin = new jQuery.gfForm(this, options);
        jQuery(this).data('gfform', plugin);
      }
    });
  };
})(jQuery);
